"use strict";

var _objectWithoutProperties = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _server = require("react-dom/server");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var colors = ['#1abc9c', '#16a085', '#f1c40f', '#f39c12', '#2ecc71', '#27ae60', '#e67e22', '#d35400', '#3498db', '#2980b9', '#e74c3c', '#c0392b', '#9b59b6', '#8e44ad', '#bdc3c7', '#34495e', '#2c3e50', '#95a5a6', '#7f8c8d', '#ec87bf', '#d870ad', '#f69785', '#9ba37e', '#b49255', '#b49255', '#a94136'];

var Initial = /*#__PURE__*/function (_react$Component) {
  _inherits(Initial, _react$Component);

  function Initial() {
    _classCallCheck(this, Initial);

    return _possibleConstructorReturn(this, _getPrototypeOf(Initial).apply(this, arguments));
  }

  _createClass(Initial, [{
    key: "unicodeCharAt",
    value: function unicodeCharAt(string, index) {
      var first = string.charCodeAt(index);
      var second;

      if (first >= 0xD800 && first <= 0xDBFF && string.length > index + 1) {
        second = string.charCodeAt(index + 1);

        if (second >= 0xDC00 && second <= 0xDFFF) {
          return string.substring(index, index + 2);
        }
      }

      return string[index];
    }
  }, {
    key: "unicodeSlice",
    value: function unicodeSlice(string, start, end, words) {
      var accumulator = '';
      var character;
      var stringIndex = 0;
      var unicodeIndex = 0;
      var nextSpace = -1;
      var length = string.length; // Remove any leading/trailing spaces

      string = string.trim();

      while (stringIndex < length) {
        character = this.unicodeCharAt(string, stringIndex);

        if (unicodeIndex >= start && unicodeIndex < end) {
          accumulator += character;
        } else {
          break;
        }

        stringIndex += character.length;
        unicodeIndex += 1; // Find the next space offset from the previous finding

        nextSpace = words ? string.indexOf(' ', nextSpace + 1) : -1;
        stringIndex = nextSpace > 0 ? nextSpace + 1 : stringIndex;
      }

      return accumulator;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          height = _this$props.height,
          textColor = _this$props.textColor,
          fontFamily = _this$props.fontFamily,
          fontSize = _this$props.fontSize,
          fontWeight = _this$props.fontWeight,
          charCount = _this$props.charCount,
          useWords = _this$props.useWords,
          name = _this$props.name,
          color = _this$props.color,
          seed = _this$props.seed,
          borderRadius = _this$props.radius,
          ownProps = _objectWithoutProperties(_this$props, ["width", "height", "textColor", "fontFamily", "fontSize", "fontWeight", "charCount", "useWords", "name", "color", "seed", "radius"]);

      var initial = this.unicodeSlice(name || 'Name', 0, charCount || 1, useWords || false).toUpperCase();
      var backgroundColor = color !== null ? color : colors[Math.floor((initial.charCodeAt(0) + seed) % colors.length)];

      var InitialSvg = function InitialSvg() {
        return /*#__PURE__*/_react.default.createElement("svg", _extends({
          xmlns: "http://www.w3.org/2000/svg",
          pointerEvents: "none"
        }, {
          width: width,
          height: height,
          style: {
            width: width,
            height: height,
            backgroundColor: backgroundColor,
            borderRadius: borderRadius
          }
        }), /*#__PURE__*/_react.default.createElement("text", {
          y: "50%",
          x: "50%",
          dy: "0.35em",
          pointerEvents: "auto",
          fill: textColor,
          fontFamily: fontFamily,
          textAnchor: "middle",
          style: {
            fontSize: fontSize,
            fontWeight: fontWeight
          },
          children: initial
        }));
      };

      var svgHtml = 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent((0, _server.renderToStaticMarkup)( /*#__PURE__*/_react.default.createElement(InitialSvg, null)))));
      return /*#__PURE__*/_react.default.createElement("img", _extends({}, ownProps, {
        src: svgHtml,
        alt: ""
      }));
    }
  }]);

  return Initial;
}(_react.Component);

exports.default = Initial;

_defineProperty(Initial, "propTypes", {
  className: _propTypes.default.string,
  style: _propTypes.default.object,
  name: _propTypes.default.string,
  color: _propTypes.default.string,
  seed: _propTypes.default.number,
  charCount: _propTypes.default.number,
  textColor: _propTypes.default.string,
  height: _propTypes.default.number,
  width: _propTypes.default.number,
  fontSize: _propTypes.default.number,
  fontWeight: _propTypes.default.number,
  fontFamily: _propTypes.default.string,
  radius: _propTypes.default.number
});

_defineProperty(Initial, "defaultProps", {
  name: 'Name',
  color: null,
  seed: 0,
  charCount: 1,
  textColor: '#ffffff',
  height: 100,
  width: 100,
  fontSize: 60,
  fontWeight: 400,
  fontFamily: 'HelveticaNeue-Light, Helvetica Neue Light, Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif',
  radius: 0
});